/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import * as Examples from './Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    code: "code",
    p: "p"
  }, _provideComponents(), props.components);
  if (!Examples) _missingMdxReference("Examples", false);
  if (!Examples.OrderHorizontal) _missingMdxReference("Examples.OrderHorizontal", true);
  if (!Examples.OrderVertical) _missingMdxReference("Examples.OrderVertical", true);
  if (!Examples.ResponsiveAdvanced) _missingMdxReference("Examples.ResponsiveAdvanced", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demo"
    }), "\n", _jsxs(_components.h2, {
      children: ["Responsive ", _jsx(_components.code, {
        children: "span"
      }), " usage"]
    }), "\n", _jsx(Examples.ResponsiveAdvanced, {}), "\n", _jsx(_components.h2, {
      children: "Tab order horizontal"
    }), "\n", _jsx(_components.p, {
      children: "In this example, the order changes, so does the tab (key) order."
    }), "\n", _jsx(Examples.OrderHorizontal, {}), "\n", _jsx(_components.h2, {
      children: "Tab order vertical"
    }), "\n", _jsx(_components.p, {
      children: "In this example, the order changes, so does the tab (key) order."
    }), "\n", _jsx(Examples.OrderVertical, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
